import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-wrap" }
const _hoisted_2 = { class: "mb-row" }
const _hoisted_3 = { class: "mb-field" }
const _hoisted_4 = {
  class: "mb-field",
  style: {"flex":"1"}
}
const _hoisted_5 = { class: "mb-field" }
const _hoisted_6 = { class: "mb-preview" }
const _hoisted_7 = { class: "mb-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("p", { class: "mb-intro" }, " Trimite instant o notificare tuturor utilizatorilor care au aplicația deschisă (fără să dea refresh). Se folosește pentru anunțuri de oprire/mentenanță. ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("label", null, "Ora la care se oprește (opțional — pentru countdown)", -1)),
        _createVNode(_component_v_text_field, {
          modelValue: _ctx.oraOprire,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.oraOprire) = $event)),
          type: "time",
          density: "compact",
          variant: "outlined",
          "hide-details": "",
          style: {"max-width":"180px"}
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[4] || (_cache[4] = _createElementVNode("label", null, "Revenire estimată", -1)),
        _createVNode(_component_v_text_field, {
          modelValue: _ctx.revenire,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.revenire) = $event)),
          placeholder: 'cât mai curând posibil',
          density: "compact",
          variant: "outlined",
          "hide-details": ""
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[5] || (_cache[5] = _createElementVNode("label", null, "Mesaj (scrie aici textul care apare la utilizatori)", -1)),
      _createVNode(_component_v_textarea, {
        modelValue: _ctx.message,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.message) = $event)),
        placeholder: 'ex: ' + _ctx.defaultMessage,
        rows: "3",
        "auto-grow": "",
        density: "compact",
        variant: "outlined",
        "hide-details": ""
      }, null, 8, ["modelValue", "placeholder"]),
      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "mb-hint" }, "Dacă lași gol, se trimite textul standard de mai jos (construit din ora + revenirea de mai sus).", -1))
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "mb-preview-label" }, "Așa va apărea la utilizatori:", -1)),
    _createElementVNode("div", _hoisted_6, [
      _cache[7] || (_cache[7] = _createElementVNode("i", { class: "dx-icon dx-icon-warning" }, null, -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.message?.trim() || _ctx.defaultMessage), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_v_btn, {
        color: "#ff2c21",
        loading: _ctx.sending,
        onClick: _ctx.send
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("mdi-bullhorn", -1)
            ]))]),
            _: 1
          }),
          _cache[9] || (_cache[9] = _createTextVNode(" Trimite notificarea ", -1))
        ]),
        _: 1
      }, 8, ["loading", "onClick"]),
      _createVNode(_component_v_btn, {
        variant: "tonal",
        loading: _ctx.clearing,
        onClick: _ctx.clearNotice
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("mdi-bell-off", -1)
            ]))]),
            _: 1
          }),
          _cache[11] || (_cache[11] = _createTextVNode(" Retrage notificarea ", -1))
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
}